import { RouteRecordRaw } from "vue-router";
const routes: RouteRecordRaw[] = [
  {
    path: "chooseSchool",
    name: "chooseSchool",
    component: () => import("@/views/choose-school/index.vue")
  },
  {
    path: "chooseSchoolTest",
    name: "chooseSchoolTest",
    component: () => import("@/views/choose-school/test.vue")
  }
];
export default routes;
